import { render, staticRenderFns } from "./ContextPill.vue?vue&type=template&id=1caaa21b"
import script from "./ContextPill.vue?vue&type=script&lang=js"
export * from "./ContextPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports